import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';

import { Observable, throwError, from, of } from 'rxjs';
import { catchError, concatMap, delay, finalize, map, mergeMap, retry, retryWhen, scan, switchMap, tap } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { NotificationService } from './notification.service';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from './user.service';
import { MessagingService } from './messaging.service';
import * as Sentry from '@sentry/browser';
import { FirebaseService } from '../shared/services/firebase.service';
import { ObsidiamJweComponent } from 'projects/obsidiam-jwe/src/public-api';
import { from as observableFrom } from "rxjs";

declare let gtag: Function;
declare var $: any;
let eventId = '';
export const retryCount = 3;
export const retryWaitMilliSeconds = 1000;
@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {
  endPoints: any;
  endPointIsJwe = false;
  constructor(
    private userService: UserService,
    private cookieService: CookieService,
    private messagingService: MessagingService,
    private route: Router,
    private translate: TranslateService,
    private notifyService: NotificationService,
    private obsidiamJweComponent: ObsidiamJweComponent,
    private fireBase: FirebaseService
  ) {
    this.route.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        gtag('config', 'UA-125115909-1', {
          cookie_flags: 'max-age=7200;secure;SameSite=Strict;HttpOnly',
          page_path: event.urlAfterRedirects
        });
      }
    });
    this.endPoints = sessionStorage.getItem('endPoints');
    this.endPoints = JSON.parse(this.endPoints);
    // console.log('this.endPoints', this.endPoints)
    if (environment.production) {
      Sentry.init({
        dsn: 'https://e87a4c78a17c4884b67af8e70cfe0d43@sentry.io/2503613',
        environment: environment.env,
        ignoreErrors: [
          'Non-Error exception captured',
          /Blocked a frame with origin/,
          'Network request failed',
          'Failed to fetch',
          'NetworkError',
          'withrealtime/messaging',
          'TypeError: Failed to fetch',
          "Non-Error promise rejection captured",
          'TypeError: NetworkError when attempting to fetch resource.',
          'Network Error'],
        beforeSend(event, hint) {
          if (!environment.production) {
            // console.log('EVENT', event, hint);
          }
          // Check if it is an exception, and if so, show the report dialog
          if (event.exception && event.exception.values.length && event.exception.values[0].type !== 'FirebaseError') {
            eventId = event.event_id;
          }
          return event;
        },
        maxBreadcrumbs: 50,
        debug: true,
      });
    }
  }

  logOut() {
    this.cookieService.deleteAll('/', location.hostname);
    this.userService.deleteUserData();
    this.userService.deleteToken();
    this.userService.setUserData({});
    this.userService.setToken('');
    this.userService.isLoggedIn = false;
    this.messagingService.changeVerificationStatus();

    localStorage.clear();

    if (!environment.production) {
      console.log('HEADER 69: HIT LOG OUT EVENT');
    }
    this.userService.logOutEventHit();
    this.route.navigate(['/']);
  }

  private isEndPointIsJwe(urlWebService: any) {
    // console.log(urlWebService, this.endPoints)
    if (!this.endPoints) {
      this.endPoints = sessionStorage.getItem('endPoints');
      this.endPoints = JSON.parse(this.endPoints);
    }
    if (this.endPoints) {
      this.endPoints.map((k) => {
        if (urlWebService.indexOf(k) != -1) {
          return true
        }
      })
      return false
    }

  }
  private async encrypt(req: any): Promise<string> {
    return new Promise((resolve, reject) => {
      if (req['url'].indexOf(environment.apiUrl) != -1 || req['url'].indexOf(environment.apiObsicashUrl) != -1) {
        if (req['url'].indexOf('obsicash-service') != -1 || req['url'].indexOf('v1/quantum') != -1) {
          this.endPointIsJwe = this.isEndPointIsJwe(req['url']);
          if (this.endPointIsJwe) {
            this.obsidiamJweComponent.encodeJweForNotObsicashAPI(true, req.body, resEnc => {
              resolve(resEnc)
            })
          } else {
            resolve(req.body)
          }
        } else {
          this.obsidiamJweComponent.encodeJweForNotObsicashAPI(true, req.body, resEnc => {
            resolve(resEnc)
          })
        }
      } else {
        resolve(req.body)
      }
    })
  }
  private async decrypt(obj: any): Promise<string> {
    return new Promise((resolve, reject) => {
      this.obsidiamJweComponent.decodeJweCallback(obj, resDec => {
        if (resDec && resDec.status === 403) {
          this.translate.get('error').subscribe((er: any) => {
            const err = er;
            this.logOut();
            this.notifyService.showError(resDec.message, err);
          });
        }
        resolve(resDec)

      })
    })
  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {


    const ETag = Math.random().toString(36).substr(2, 9);
    if (request.url.indexOf('translation.googleapis') === -1) {
      request = request.clone({ headers: request.headers.set('ETag', ETag) });
    }
    let isLoader = true;
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < environment.allowLoader.length; i++) {
      if (request.url.indexOf(environment.allowLoader[i]) !== -1) {
        isLoader = false;
      }
    }
    if (!isLoader) {
      $('#loading').css({ display: 'block' });
      $('#loading').show();

    }
    let params;
    params = request.params;
    return observableFrom(this.encrypt(request))
      .pipe(
        switchMap(data => { // do the changes here
          // const headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json');

          const modified = request.clone({
            body: data,
            responseType: request['url'] && (request['url'].indexOf(environment.apiUrl) != -1 || request['url'].indexOf(environment.apiObsicashUrl) != -1) ? 'text' : 'json',
            // headers: headers
          });
          return next.handle(modified.clone({
            params
          }))
            .pipe(
              map((event: HttpEvent<any>) => {
                // console.log(event, event['url'], event['body'], this.decrypt(event['body']));
                if (request['url'] && (request['url'].indexOf(environment.apiUrl) != -1 || request['url'].indexOf(environment.apiObsicashUrl) != -1) && event['body']) {
                  if (request['url'].indexOf('obsicash-service') != -1 || request['url'].indexOf('v1/quantum') != -1) {
                    this.endPointIsJwe = this.isEndPointIsJwe(request['url']);
                    // console.log(this.endPointIsJwe)
                    if (this.endPointIsJwe) {
                      event['body'] = this.decrypt(event['body'])
                    }
                  } else {
                    event['body'] = this.decrypt(event['body'])
                  }

                  return event;
                }
                return event;
              }),
              retryWhen(error => {
                return error.pipe(
                  mergeMap(error => {
                    // console.log('error.status', error.status)
                    if (error.status !== 401) {
                      return of(error);
                    }
                    this.logOut();
                    return throwError(error);
                  }),
                  scan((acc, error) => {
                    if (acc > 3) throw error;
                    return acc + 1;
                  }, 0),
                  // tap((c) => console.log(`retrying ${c}`)),
                  tap((c) => console.log('')),
                  delay(2000),
                );
              }),
              catchError(error => {
                if (!environment.production) {
                  console.log('test', error);
                }
                $('#loading').css({ display: 'none' });
                $('#loading').hide();

                $('body').css({ 'pointer-events': 'auto' });

                if (error.status === 500) {
                  Sentry.configureScope(scope => {
                    scope.setTag('transaction_id', ETag);
                  });

                  Sentry.captureMessage('Something went wrong');
                  $('.modal').modal('hide');
                  Sentry.showReportDialog({ eventId: eventId });
                } else if (error.status === 401) {
                  this.logOut();

                } else {
                  if (!environment.production && error.status !== 200) {
                    console.log(error);
                  }

                  if (error.name === 'HttpErrorResponse' && error.status !== 200 && error.status !== 429) {
                    const exception = error.error || error.message || error.originalError || error;
                    Sentry.captureException(exception);
                    this.route.navigate(['/not-connected']);
                  }
                }
                return throwError(error);
              }),
              finalize(() => {
                $('#loading').css({ display: 'none' });
                $('#loading').hide();

                $('body').css({ 'pointer-events': 'auto' });
              })
            );
        }))
    // return next.handle(request).pipe(
    //   map((event: HttpEvent<any>) => {
    //     if (event instanceof HttpResponse) {
    //       if (event.body && event.body.status === 403) {
    //         this.translate.get('error').subscribe((er: any) => {
    //           const err = er;
    //           this.logOut();
    //           this.notifyService.showError(event.body.message, err);
    //         });
    //       }
    //     }
    //     return event;
    //   }),
    //   retryWhen(error => {
    //     return error.pipe(
    //       mergeMap(error => {
    //         // console.log('error.status', error.status)
    //         if (error.status !== 401) {
    //           return of(error);
    //         }
    //         this.logOut();
    //         return throwError(error);
    //       }),
    //       scan((acc, error) => {
    //         if (acc > 3) throw error;
    //         return acc + 1;
    //       }, 0),
    //       // tap((c) => console.log(`retrying ${c}`)),
    //       tap((c) => console.log('')),
    //       delay(2000),
    //     );
    //   }),
    //   catchError((error: any) => {
    //     if (!environment.production) {
    //       console.log('test', error);
    //     }
    //     $('#loading').css({ display: 'none' });
    //     $('#loading').hide();

    //     $('body').css({ 'pointer-events': 'auto' });

    //     if (error.status === 500) {
    //       Sentry.configureScope(scope => {
    //         scope.setTag('transaction_id', ETag);
    //       });

    //       Sentry.captureMessage('Something went wrong');
    //       $('.modal').modal('hide');
    //       Sentry.showReportDialog({ eventId: eventId });
    //     } else if (error.status === 401) {
    //       this.logOut();

    //     } else {
    //       if (!environment.production && error.status !== 200) {
    //         console.log(error);
    //       }

    //       if (error.name === 'HttpErrorResponse' && error.status !== 200 && error.status !== 429) {
    //         const exception = error.error || error.message || error.originalError || error;
    //         Sentry.captureException(exception);
    //         this.route.navigate(['/not-connected']);
    //       }
    //     }
    //     return throwError(error);
    //   }),
    //   finalize(() => {
    //     $('#loading').css({ display: 'none' });
    //     $('#loading').hide();

    //     $('body').css({ 'pointer-events': 'auto' });
    //   }));
  }
}